h2 Enable Two-factor authentication

button#g-user-otp-initialize-enable.btn.btn-primary(type="submit")
  |  Begin
